import { useState } from 'react';
import LoginScreen from '@/components/LoginScreen';
import MainScreen from '@/components/MainScreen';
import { getToken, clearToken } from '@/lib/api';

export default function App() {
  const [authed, setAuthed] = useState(() => Boolean(getToken()));

  if (!authed) return <LoginScreen onAuth={() => setAuthed(true)} />;
  return <MainScreen onLogout={() => { clearToken(); setAuthed(false); }} />;
}
